import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useCatalogCategories, CatalogCategory } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<CatalogCategory>
      useData={useCatalogCategories}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
